itsoftApp.createModule("shavingText", ["pageLoad", "windowResize"], function () {
    var module = this;

    var textEls = document.querySelectorAll(".js-shave");

    var initTruncate = function (els) {
        itsoftApp.loadScript("/assets/scripts/clampify/clampify.min.js", function () {
            var addClickListener = function (el, end, textEl) {
                if (end) {
                    end.addEventListener("click", function (evt) {
                        evt.preventDefault();
                        el.classList.add("js-show");
                        textEl.clampify.destroy();
                    });
                }
            }

            Array.prototype.forEach.call(textEls, function (el) {
                var textEl = $clampify(el, {
                    maxLines: 0,
                    autoUpdate: true
                });

                if (!el.classList.contains("js-shave-default")) {
                    var end = textEl.querySelector(".clampify-destroy");

                    addClickListener(el, end, textEl);

                    itsoftApp.modules.windowResize.addEvent(function () {
                        var end = textEl.querySelector(".clampify-end");
                        addClickListener(el, end, textEl);
                    })
                }
            })
        });
    }

    if (textEls) {
        initTruncate(textEls);
    }

    module.callback = initTruncate;
})